export const accordionTheme = {
  colorScheme: {
    light: {
      root: {
        transitionDuration: '{transition.duration}'
      },
      panel: {
        borderWidth: '0px',
        borderColor: '{content.border.color}'
      },
      header: {
        color: '{text.muted.color}',
        hoverColor: '{text.color}',
        hoverBackground: '{content.hover.background}',
        activeColor: '{text.color}',
        activeBackground: '{content.background}',
        activeHoverBackground: '{content.hover.background}',
        padding: '1.125rem',
        fontWeight: '700',
        borderRadius: '0',
        borderWidth: '0 0 1px 0',
        borderColor: '{content.border.color}',
        background: '{content.background}',
        focusRing: {
          width: '{focus.ring.width}',
          style: '{focus.ring.style}',
          color: '{focus.ring.color}',
          offset: '{focus.ring.offset}',
          shadow: '{focus.ring.shadow}'
        },
        toggleIcon: {
          color: '{text.muted.color}',
          hoverColor: '{text.color}',
          activeColor: '{text.color}',
          activeHoverColor: '{text.color}'
        },
        first: {
          topBorderRadius: '{content.border.radius}',
          borderWidth: '0'
        },
        last: {
          bottomBorderRadius: '{content.border.radius}',
          activeBottomBorderRadius: '0'
        }
      },
      content: {
        borderWidth: '0 0 0px 0',
        borderColor: 'var(--surface-stroke)',
        background: '{content.background}',
        color: '{text.color}',
        padding: '1.125rem'
      }
    },
    dark: {
      root: {
        transitionDuration: '{transition.duration}'
      },
      panel: {
        borderWidth: '0px',
        borderColor: '{content.border.color}'
      },
      header: {
        color: '{text.muted.color}',
        hoverColor: '{text.color}',
        hoverBackground: '{content.hover.background}',
        activeColor: '{text.color}',
        activeBackground: '{content.background}',
        activeHoverBackground: '{content.hover.background}',
        padding: '1.125rem',
        fontWeight: '700',
        borderRadius: '0',
        borderWidth: '0 0 1px 0',
        borderColor: '{content.border.color}',
        background: '{content.background}',
        focusRing: {
          width: '{focus.ring.width}',
          style: '{focus.ring.style}',
          color: '{focus.ring.color}',
          offset: '{focus.ring.offset}',
          shadow: '{focus.ring.shadow}'
        },
        toggleIcon: {
          color: '{text.muted.color}',
          hoverColor: '{text.color}',
          activeColor: '{text.color}',
          activeHoverColor: '{text.color}'
        },
        first: {
          topBorderRadius: '{content.border.radius}',
          borderWidth: '0'
        },
        last: {
          bottomBorderRadius: '{content.border.radius}',
          activeBottomBorderRadius: '0'
        }
      },
      content: {
        borderWidth: '0 0 0px 0',
        borderColor: 'var(--surface-stroke)',
        background: '{content.background}',
        color: '{text.color}',
        padding: '1.125rem'
      }
    }
  }
};
